import BaseModel, {defineTranslatableProperties} from "../../core/components/input-widget/BaseModel";
import FinancialItemModel from "@/modules/invoices/models/FinancialItem.model";
import i18n from './../../shared/i18n';
import i18nHelper from "@/core/services/i18n.service";
import {store} from "@/plugins/vuex";
import SettlementChargeModel from "@/modules/settlements/SettlementCharge.model";
import {Formatter} from "@/core/services/formatter.service";

export default class SettlementModel extends BaseModel {
  uuid = null;
  customer_uuid = null;
  auction_uuid = null;
  sale_no = null;
  financial_items = [];
  unsettled_financial_items = [];
  miscellaneous_items = [];
  preferred_language_code = null;
  last_synced_at = null;
  additional_page = false;
  settlement_charges = [];
  enable_shipping = false;
  shipping_amount = null;
  shipping_vat = null;
  shipping_taxable = null;
  shipping_tracking_code = null;
  date = Formatter.getCurrentDate();
  is_exported = null;
  comment = null;
  settlement_billing_address = null;

  rules = {
    preferred_language_code: 'required',
    customer_uuid: 'required',
    auction_uuid: store.state.global.enableContinuousAuction ? '' : 'required',
    lot_uuid: store.state.global.enableContinuousAuction ? 'required' : '',
  };

  attributeLabels = {
    no: i18n.t('No'),
    data: i18n.t('Data'),
    bidder: i18n.t('Bidder'),
    branch: i18n.t('Branch'),
    status: i18n.t('Status'),
    auction: i18n.t('Auction'),
    currency: i18n.t('Currency'),
    customer_uuid: i18n.t('Customer'),
    auction_uuid: i18n.t('Sale Number'),
    lot_uuid: i18n.t('Lot Number'),
    preferred_language_code: i18n.t('Preferred Language'),
    additional_page: i18n.t('Charges Breakdown'),
    date: i18n.t('Date'),
    is_exported: i18n.t('Exported'),
  };

  attributePlaceholders = this.attributeLabels;

  attributeHints = {
    preferred_language_code: i18n.t('Settlement template will be created according to the selected language'),
  }

  constructor(data = {}) {
    super();

    if (data.miscellaneous_items) {
      data.miscellaneous_items = data.miscellaneous_items.map(mi => {
        return {
          checked: !!mi.settlement_uuid,
          ...mi
        }
      })
    }

    if (data.financial_items) {
      data.financial_items = data.financial_items.map(item => new FinancialItemModel(item))
    }

    if (data.unsettled_financial_items) {
      data.unsettled_financial_items = data.unsettled_financial_items.map(item => new FinancialItemModel(item))
    }

    if (data.settlement_charges) {
      data.settlement_charges = data.settlement_charges.map(item => new SettlementChargeModel(item))
    }

    if (data.extra_info && Object.keys(data.extra_info).length > 0) {
      for (let key in data.extra_info) {
        data[key] = data.extra_info[key]
      }
    }

    Object.assign(this, {...data});
    this.preferred_language_code = this.preferred_language_code || i18nHelper.getMasterLanguage().key;

    // Enable shipping checkbox if amount is present and is more than 0
    if (this.shipping_amount && this.shipping_amount > 0) {
      this.enable_shipping = true;
    }
  }
}

defineTranslatableProperties(SettlementModel);
